import { createFileRoute } from '@tanstack/react-router';
import { JourneysCampaignSetupHandoff } from '@/pages/workspaces/automations/[campaignId]/workflow/routing';

function JourneysCampaignsSetupReviewRoute() {
  const { campaignId } = Route.useParams();
  return <JourneysCampaignSetupHandoff campaignId={campaignId} step="review" />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/setup/review',
)({
  component: JourneysCampaignsSetupReviewRoute,
});
